var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('paginate',{attrs:{"pageCount":_vm.pageCount,"pageRange":_vm.pageRange,"clickHandler":_vm.clickHandler,"prevText":_vm.gettext('Prev'),"nextText":_vm.gettext('Next'),"containerClass":'pagination',"forcePage":_vm.initialPage,"initialPage":_vm.initialPage}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4206682b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/paginate/index.vue
// module id = null
// module chunks = 